import useApi from './request'

export async function getGroupShareInfoApi(groupId: string) {
  let { response, request } = useApi<any>(`/group/share/info/${groupId}`, {
    method: 'POST',
  })
  await request()
  return response
}

export async function getUserShareInfoApi(userId: string) {
  let { response, request } = useApi<any>(`/user/share/info/${userId}`, {
    method: 'POST',
  })
  await request()
  return response
}
